import * as LabelPrimitive from '@radix-ui/react-label'
import {cva, type VariantProps} from 'class-variance-authority'
import * as React from 'react'

import {cn} from '@/lib/utils'

const labelVariants = cva(
  'text-xs font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:text-gray-subtle peer-readonly:text-gray-subtle peer-required:after:content-["*"] peer-required:after:ml-[2px] peer-required:after:text-red-deep peer-aria-[required]:after:content-["*"] peer-aria-[required]:after:ml-[2px] peer-aria-[required]:after:text-red-deep',
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({className, ...props}, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export {Label}
